module.exports = __webpack_public_path__ + "img/GetWell.9b9b8264.png";